import { Typography as T, TypographyProps } from "@mui/material";

const ResultLabel = (props: TypographyProps) => (
  <T variant="label" fontSize={12} lineHeight={1} m={0} mr={0.75} whiteSpace="nowrap" {...props} />
);

export default ResultLabel;
